module.exports = __webpack_public_path__ + "static/media/5.17_preview.138a3733.png";